import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch, nextTick, toRef } from 'vue';
import { useSwiper, ManagedSwiper, SwiperNavigationButton } from '@/ui/shared/swiper';
import { useOnWindowResize, useOnSelfResize, useRootComponentWidth } from '@/ui/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'SwipeSelector',
  props: {
    options: null,
    value: null,
    spaceBetween: { default: 20 },
    navigationButtonWidth: { default: 20 }
  },
  emits: ['input', 'change'],
  setup(__props: any, { emit }) {

const props = __props as { options: any[], value: any, spaceBetween: number, navigationButtonWidth: number }





const handleSlideClick = (slide: any) => {
    emit('input', slide);
    emit('change', slide);
};

const { swiperManager } = useSwiper<string>({
    slides: toRef(props, 'options'),
    swiperOptions: {
        slidesPerView: 'auto',
        slidesPerGroupAuto: true,
        loop: false,
        centeredSlides: false,
        spaceBetween: props.spaceBetween,
        watchOverflow: false
    }
});

const { rootComponentWidth } = useRootComponentWidth();

const calculateSlidesWidth = () => {
    const swiperEl = swiperManager.getSwiperElement() as HTMLElement;
    const slideElements = swiperEl.querySelectorAll('.swiper-slide');
    const slidesTotalWidth = Array.from(slideElements).reduce((acc, el) => acc + el.clientWidth, 0);
    const marginsWidth = (props.options.length - 1) * props.spaceBetween;
    return slidesTotalWidth + marginsWidth;
};
const totalSlidesWidth = ref(200);
const showNavigation = ref(false);
const updateWidthBasedRefs = () => {
    totalSlidesWidth.value = calculateSlidesWidth();
    showNavigation.value = totalSlidesWidth.value > rootComponentWidth.value;
};
watch(() => props.options, () => {
    nextTick(() => {
        updateWidthBasedRefs();
    });
});

useOnWindowResize(updateWidthBasedRefs);
useOnSelfResize(updateWidthBasedRefs);
onMounted(() => {
    updateWidthBasedRefs();
});


return { __sfc: true,emit, props, handleSlideClick, swiperManager, rootComponentWidth, calculateSlidesWidth, totalSlidesWidth, showNavigation, updateWidthBasedRefs, ManagedSwiper, SwiperNavigationButton }
}

})